import { GET_BILL_CREDIT_FORM_DATA_SUCCESS, GET_BILL_CREDIT_FORM_DATA_REQUEST, GET_BILL_CREDIT_FORM_DATA_ERROR } from "../actions/types";




export default function (state = [], action) {
	const { type, payload } = action;
	switch (type) {
		case GET_BILL_CREDIT_FORM_DATA_REQUEST:
			return {
				loading: true,
			};
		case GET_BILL_CREDIT_FORM_DATA_SUCCESS:
			return {
				...state,
				loading: false,
				payload,
			};
		case GET_BILL_CREDIT_FORM_DATA_ERROR:
			return {
				...state,
				loading: false,
			};
		default:
			return state;
	}
}